import TagManager, { DataLayerArgs, TagManagerArgs } from 'react-gtm-module'

export class AnalyticsAgent {
  push(dataLayer: DataLayerArgs): void {
    if (process.env.NODE_ENV === 'development') {
      return
    }
    TagManager.dataLayer({
      dataLayer: dataLayer.dataLayer,
      dataLayerName: 'DigitalFarmer',
    })
  }

  page(page: string) {
    if (process.env.NODE_ENV === 'development') {
      return
    }
    const tagManagerArgs = {
      dataLayer: {
        page: page,
      },
    }
    TagManager.dataLayer(tagManagerArgs)
  }

  initialize() {
    if (process.env.NODE_ENV === 'development') {
      return
    }
    const gtm_auth = process.env.REACT_APP_GTM_AUTH
    const gtm_preview = process.env.REACT_APP_GTM_PREVIEW
    let tagManagerArgs: TagManagerArgs = {
      gtmId: process.env.REACT_APP_GTM_ID ?? '',
      dataLayerName: 'DigitalFarmer',
    }

    if (gtm_auth && gtm_preview) {
      tagManagerArgs = {
        ...tagManagerArgs,
        auth: gtm_auth,
        preview: gtm_preview,
      }
    }

    TagManager.initialize(tagManagerArgs)
  }
}

const Analytics = new AnalyticsAgent()

export default Analytics
